import { render } from "./PatientPharmacy.vue?vue&type=template&id=2ddd9cfa"
import script from "./PatientPharmacy.vue?vue&type=script&lang=js"
export * from "./PatientPharmacy.vue?vue&type=script&lang=js"

import "./PatientPharmacy.vue?vue&type=style&index=0&id=2ddd9cfa&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__